export const GET_ACCOUNT_MAPPINGS = `
  query getAccountMappings($year: Int!) {
    listAccountMapping(year: $year) {
      existingMappings {
        accountId
        id
        mappings {
            startDate
            accountType
            endDate
            reference
            insertedDate
            allocations {
              element1Id
              element2Id
              element3Id
              element4Id
              percentage
            }
          }
      }
      error {
        code
        message
        statusCode
      }
    }
  }
`
